<template>
  <div v-if="componentReadyToRender">
    <universal-navigator />
    <router-view></router-view>
  </div>
  <TheGlobalLoading v-else />
</template>

<script>
import TokenRequest from '@/services/request/tokenRequest';
import { bootstrap, casEnabled } from './auth/authService';
import CASTokenStrategy from './auth/tokenStrategies/casTokenStrategy';
import TheGlobalLoading from './screens/Layout/components/TheGlobalLoading';
import TokenStrategyFactory from './auth/tokenStrategies/tokenStrategyFactory';

const tokenRequest = new TokenRequest();

export default {
  name: 'app',
  components: { TheGlobalLoading },
  data() {
    return {
      publicRoutes: ['Logout', 'Surrogate'],
      componentReadyToRender: false,
    };
  },
  async mounted() {
    if (this.publicRoutes.includes(this.$route.name)) {
      if (casEnabled()) {
        bootstrap.stop();
      }
      this.componentReadyToRender = true;
    } else {
      await this.setupAuthentication();

      this.setGoogleAnalyticsUser();
    }
  },
  methods: {
    async setupAuthentication() {
      if (casEnabled()) {
        bootstrap.subscribe({
          next: async (casUser) => {
            new CASTokenStrategy().setToken(casUser.id_token);

            await this.handleToken();

            this.componentReadyToRender = true;
          },
        });

        const bootstrapConfig = { appName: 'klickart-analytics-client' };
        bootstrap.start(bootstrapConfig);
      } else {
        await this.handleToken();

        this.componentReadyToRender = true;
      }
    },

    async handleToken() {
      await tokenRequest.token();
    },

    setGoogleAnalyticsUser() {
      const token = TokenStrategyFactory.getTokenStrategy('jwt').getToken();
      const decodedToken = tokenRequest.decodeToken(token);

      this.$ga.set('userId', decodedToken.userProfile.apiKey);
      this.$ga.page(this.$router);
    },
  },
};
</script>

<style lang="scss">
@import './assets/scss/main';
  :root {
    font-size: var(--text-2);
    height: auto;
  }
  [role=MenuItem] {
    span {
      font-size: var(--text-2);
    }
  }
  [role=SubmenuItem] {
    font-size: var(--text-2);
    padding: 8px 0px 0px 0px;
  }
  hot-avatar {
    font-size: var(--text-1, 0.75rem)
  }
  .dropdown-header {
    text-align: -webkit-center;
  }
  .profile-drawer {
      &__menu-header {
        &__user-info {
          p {
            padding: 2px 0px 5px 0px;
          }
        }
      }
    }

</style>



// WEBPACK FOOTER //
// src/App.vue